import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listConfig: [],
  isShowConfig: false,
  defaultStatus: {},
};

const slice = createSlice({
  name: "agentStatus",
  initialState,
  reducers: {
    setShowConfig(state, action) {
      state.isShowConfig = action.payload;
    },
    getListConfig() {},
    getListConfigResult(state, action) {
      state.listConfig = action.payload;
    },
    createConfig() {},
    updateConfig() {},
    deleteConfig() {},
    markDefaultConfig() {},
    getSpecificUserStatus() {},
    getSpecificUserStatusResult(state, action) {
      state.defaultStatus = action.payload;
    },
  },
});

//Reducer
export default slice.reducer;

//Actions
export const {
  setShowConfig,
  getListConfig,
  getListConfigResult,
  createConfig,
  updateConfig,
  deleteConfig,
  markDefaultConfig,
  getSpecificUserStatus,
  getSpecificUserStatusResult,
} = slice.actions;
